import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Swal from "sweetalert2";
import { getFileByPath, StockInWardExcelFileFormat, StockInWardExcelUpload } from "../../Utilities/URLCONSTANTS";
import Loader_Bulk from '../../Utilities/Loader_Bulk';
import { GetApiHeaders, GetApiHeadersWithToken } from "../../Utilities/NetworkUtilities";
import SideMenu from "../../Pages/SideMenu";
import axios from "axios";

const MassUpload = () => {
    const [file, setFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [uploadStatus, setUploadStatus] = useState({ successCount: null, failureCount: null });
    const navigate = useNavigate();

    const handleUpload = (event) => {
        setFile(event.target.files[0]);
    };

    const handleDownloadExcelResponcePath = async (excelPath) => {
        if (!excelPath || !excelPath.imagePath) {
            Swal.fire({
                icon: "error",
                title: "Download Error",
                text: "No file available for download.",
                showConfirmButton: true,
            });
            return;
        }

        try {
            const fileServerAuthCode = await GetApiHeadersWithToken();

            // Get imagePath from request object
            const imagePath = excelPath.imagePath?.trim();

            console.log("Image Path:", imagePath);
            console.log("Image Path JSON:", JSON.stringify(imagePath));
            console.log("getFileByPath:", getFileByPath);

            // Build media URL without spaces
            const mediaUrl = `${getFileByPath}?imagePath=${imagePath}`;

            console.log("Media API URL:", mediaUrl);

            const fileResponse = await axios.get(mediaUrl, {
                headers: {
                    fileServerAuthCode: fileServerAuthCode,
                },
                responseType: "blob",
            });

            console.log("File Blob:", fileResponse.data);

            // Create blob URL
            const blobUrl = URL.createObjectURL(fileResponse.data);

            // Get file name
            const fileName = imagePath.split("/").pop();

            console.log("File Name:", fileName);

            // Download file
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = fileName;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Release blob URL
            setTimeout(() => {
                URL.revokeObjectURL(blobUrl);
            }, 100);

        } catch (error) {
            console.error("Error downloading Excel file:", error);
            console.error("Error response:", error?.response?.data);

            Swal.fire({
                icon: "error",
                title: "Download Error",
                text: "An error occurred while downloading the Excel file. Please try again later.",
                showConfirmButton: true,
            });
        }
    };


    const handleSubmit = async (event) => {
        event.preventDefault();
        const headers = await GetApiHeaders();
        if (!file) {
            Swal.fire({
                icon: "warning",
                title: "No File Selected",
                text: "Please select a file to upload.",
                showConfirmButton: true,
            });
            return;
        }
        const validExtensions = [".xlsx"];
        const maxFileSize = 5 * 1024 * 1024;
        const fileName = file.name.toLowerCase();
        const fileExtension = fileName.slice(fileName.lastIndexOf("."));
        if (!validExtensions.includes(fileExtension)) {
            Swal.fire({
                icon: "error",
                title: "Invalid File Type",
                text: "Please upload a valid Excel file (.xlsx).",
                showConfirmButton: true,
            });
            return;
        }
        if (file.size === 0) {
            Swal.fire({
                icon: "error",
                title: "Empty File",
                text: "The uploaded file is empty. Please upload a valid Excel file.",
                showConfirmButton: true,
            });
            return;
        }
        if (file.size > maxFileSize) {
            Swal.fire({
                icon: "error",
                title: "File Too Large",
                text: "The file size exceeds the 5MB limit. Please upload a smaller file.",
                showConfirmButton: true,
            });
            return;
        }
        const formData = new FormData();
        formData.append("excelFile", file);
        setIsLoading(true);
        try {
            delete headers["Content-Type"];
            const response = await fetch(StockInWardExcelUpload, {
                method: "POST",
                body: formData,
                headers,
            });
            const result = await response.json();
            if (response.ok && result.statusCode == "200") {
                setUploadStatus({
                    successCount: result.response.successCount,
                    failureCount: result.response.failureCount,
                });

                Swal.fire({
                    icon: "success",
                    html: `<span style="color: #4A7729;">${result.message}</span>`,
                    confirmButtonText: "OK",
                    confirmButtonColor: "#4A7729",
                    showConfirmButton: true,
                }).then((swalResult) => {
                    if (swalResult.isConfirmed && result.response.excelPath) {

                        const fileUrlObject = new URL(result.response.excelPath);

                        const imagePath = fileUrlObject.searchParams.get("imagePath");

                        const requestObject = {
                            imagePath: imagePath,
                        };
                        console.log("Download Request Object:", requestObject);
                        handleDownloadExcelResponcePath(requestObject);
                    }
                });


            } else {
                Swal.fire({
                    icon: "error",
                    title: result.message,
                    text: `Failures: ${result.response.failureCount}, Successes: ${result.response.successCount}`,
                    showConfirmButton: true,
                });
                setUploadStatus({
                    successCount: result.response.successCount,
                    failureCount: result.response.failureCount,
                });
            }
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "An error occurred while uploading the file.",
                showConfirmButton: true,
            });
        } finally {
            setIsLoading(false);
        }
    };


    const downloadExcelTemplate = async () => {
        const url = StockInWardExcelFileFormat;
        try {
            const headers = await GetApiHeaders();
            const fileServerAuthCode = await GetApiHeadersWithToken();
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    ...headers,
                    "Content-Type": "application/json",
                    fileServerAuthCode: fileServerAuthCode,
                },
                body: JSON.stringify({}),
            });

            if (response.ok) {
                const result = await response.json();
                if (result.statusCode == "200" && result.response) {
                    const fileUrl = result.response;

                    // Get imagePath from response URL
                    const fileUrlObject = new URL(fileUrl);
                    const imagePath =
                        fileUrlObject.searchParams.get("imagePath");

                    console.log("imagePath:", imagePath);

                    if (!imagePath) {
                        Swal.fire({
                            icon: "error",
                            text: "Image path not found.",
                        });
                        return;
                    }

                    // Request object
                    const requestObject = {
                        imagePath: imagePath,
                    };

                    console.log("Request Object:", requestObject);

                    // Media API call
                    const fileResponse = await axios.get(getFileByPath, {
                        params: requestObject,
                        headers: {
                            fileServerAuthCode: fileServerAuthCode,
                        },
                        responseType: "blob",
                    });

                    // Create download URL
                    const blobUrl = URL.createObjectURL(fileResponse.data);

                    const fileName = imagePath.split("/").pop();

                    const link = document.createElement("a");
                    link.href = blobUrl;
                    link.setAttribute("download", fileName);

                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    setTimeout(() => {
                        URL.revokeObjectURL(blobUrl);
                    }, 100);
                } else {
                    Swal.fire({
                        icon: "error",
                        text: result.message || "Failed to download Excel template.",
                    });
                }
            } else {
                Swal.fire({
                    icon: "error",
                    text: "Failed to download Excel template.",
                });
            }
        } catch (error) {
            console.error("Download Excel Error:", error);

            Swal.fire({
                icon: "error",
                text: "Something went wrong while downloading the Excel template.",
            });
        }
    };

    return (
        <div>
            {isLoading && <Loader_Bulk />}
            <header style={{ padding: "8px", backgroundColor: "#4A7729", textAlign: "center", color: "#fff" }}>
                <h5>Bulk Upload</h5>
            </header>
            <div className="container mt-5">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link
                                to="/StockInWard"
                                state={{ activeItem: "StockInWard" }}
                                style={{ cursor: "pointer", color: "#4A7729" }}
                            >
                                <h5>Go Back</h5>
                            </Link>
                        </li>
                    </ol>
                </nav>
                <h3 className="mb-4">Bulk Upload</h3>
                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label htmlFor="fileUpload" className="form-label">Excel File</label>
                        <div className="col-md-6">
                            <input
                                type="file"
                                id="fileUpload"
                                className="form-control-file"
                                onChange={handleUpload}
                                accept=".xlsx"
                            />
                            <label className="custom-file-label" htmlFor="fileUpload">
                                {file ? file.name : "Choose file"}
                            </label>
                        </div>
                    </div>

                    <div style={{ marginTop: "2.5rem" }}>
                        <button
                            className="btn btn-link"
                            onClick={downloadExcelTemplate}
                            type="button"
                            style={{
                                fontSize: "13px",
                                color: "#4A7729",
                            }}
                        >
                            <i
                                className="bi bi-file-earmark-arrow-down"
                                style={{ color: "#4A7729" }}
                            ></i>
                            <span style={{ color: "#4A7729" }}>
                                Download Excel Template
                            </span>
                        </button>
                    </div>

                    <div style={{ marginBottom: '60px' }}></div>
                    <div className="d-flex justify-content-center gap-2">
                        <button type="submit" className="btn btn-primary" disabled={isLoading}>
                            Submit
                        </button>
                        <button
                            type="button"
                            className="btn btn-danger"
                            onClick={() => {
                                setFile(null);
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </div>

            {/* Display successCount and failureCount */}
            {uploadStatus.successCount !== null && uploadStatus.failureCount !== null && (
                <div style={{ marginTop: "20px", textAlign: "center" }}>
                    <p>
                        <strong>Success Count:</strong> {uploadStatus.successCount}
                    </p>
                    <p>
                        <strong>Failure Count:</strong> {uploadStatus.failureCount}
                    </p>
                </div>
            )}
            <footer style={{
                padding: "1px",
                textAlign: "center",
                marginTop: "300px"
            }}>
                <p>&copy; Multi Crop Research Center</p>
            </footer>
        </div>
    );
};

export default MassUpload;
